const classname = '.wp-block-wonder-blocks-image-carousel';

function setupCarousel() {
	const content = document.querySelector(`${classname} .content`);
	const blocks = document.querySelectorAll(`${classname} .content > *`);

	if (blocks.length === 0)
		return;

	content.innerHTML += blocks[0].outerHTML;
}


function slide() {
	setTimeout(() => {
		const list = document.querySelector(`${classname} .wrapper`);
		const page = document.querySelector(`${classname} .wrapper .content > *`);
		const w = page.offsetWidth;

		if (list.scrollLeft >= list.scrollWidth - w) {
			list.scrollTo({
				left: 0,
				behavior: 'instant'
			});
		}

		list.scrollBy({
			left: w,
			behavior: 'smooth'
		});

		slide();
	}, 3000);
}


window.addEventListener('load', () => {
	setupCarousel();

	slide();
});
